// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1uQdh","select":"Header_select__1XYYV","clinic":"Header_clinic__2F1jI"};